import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Events() {
  const [rows, setRows] = useState([]);
  const [domain, setDomain] = useState("");
  const [action, setAction] = useState("");

  const load = async () => {
    try {
      const params = { limit: 300 };
      if (domain) params.domain = domain;
      if (action) params.action = action;
      const { data } = await api.get("/events", { params });
      setRows(Array.isArray(data) ? data : []);
    } catch (e) { toast.error(formatApiError(e)); }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 10000);
    return () => clearInterval(iv);
  }, [domain, action]);

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">Olay Günlüğü</h1>
          <p className="text-sm text-muted-foreground mt-1">Tüm sistem olayları · agent + worker + panel</p>
        </div>
        <div className="flex gap-2">
          <div className="relative">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input placeholder="domain" value={domain} onChange={(e) => setDomain(e.target.value)} className="pl-8 w-56" data-testid="events-domain-filter" />
          </div>
          <Input placeholder="action (örn: zone-change)" value={action} onChange={(e) => setAction(e.target.value)} className="w-56" data-testid="events-action-filter" />
          <Button variant="secondary" onClick={load}>Yenile</Button>
        </div>
      </div>

      <div className="border border-border bg-card rounded-md overflow-hidden">
        <table className="data-table" data-testid="events-table">
          <thead>
            <tr>
              <th>Zaman</th>
              <th>Kaynak</th>
              <th>Action</th>
              <th>Domain</th>
              <th>Durum</th>
              <th>Mesaj</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="text-center py-10 text-muted-foreground text-sm font-mono">olay yok</td></tr>
            )}
            {rows.map((ev) => (
              <tr key={ev.id} data-testid={`event-row-${ev.id}`}>
                <td className="font-mono text-[10px] text-muted-foreground whitespace-nowrap">{new Date(ev.created_at).toLocaleString("tr-TR")}</td>
                <td><span className="status-badge info">{ev.source}</span></td>
                <td className="font-mono text-xs">{ev.action}</td>
                <td className="font-mono text-xs">{ev.domain || "—"}</td>
                <td>
                  <span className={`status-badge ${ev.status === "success" ? "ok" : ev.status === "error" ? "err" : "info"}`}>
                    {ev.status}
                  </span>
                </td>
                <td className="text-xs text-muted-foreground">{ev.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
